import { ModelKeys } from "../../../../types/sections/technicians";

export const DEFAULT_TABS = {
	DEPARTMENTS_LABEL: "Departments",
	OPERATION_CODES_LABEL: "Operation Codes",
};

export const DEFAULT_KEYS: Record<string, ModelKeys> = {
	DEPARTMENTS_KEY: "departments",
	OPERATION_CODES_KEY: "operationCodes",
};

export const EMPTY_MESSAGE = "Please add one or more targeted performance bonus.";
